// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"editCreate_formContainer__2ojgK","form":"editCreate_form__2llF8"};